import { defineSlotRecipe } from '@chakra-ui/react'

export const showHideButton = defineSlotRecipe({
  className: 'ShowHideButton',
  slots: ['showHideButton', 'container'],
  base: {
    container: {
      border: '1px solid rgba(255, 255, 255, 0.50)',
    },
  },
})
